import { KeyConstructor } from './keyConstructor';
const TEMPLATES_KEY = 'templates';
const TEMPLATE_REQUEST_KEY = 'templateRequest';
export const getTemplatesKey = KeyConstructor(TEMPLATES_KEY);
export const getTemplateRequestKey = KeyConstructor(TEMPLATE_REQUEST_KEY);
//# sourceMappingURL=template.key.js.map